import { render, staticRenderFns } from "./ArticleChart.vue?vue&type=template&id=47d4957e&"
import script from "./ArticleChart.vue?vue&type=script&lang=js&"
export * from "./ArticleChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports